var render = function render(){var _vm=this,_c=_vm._self._c;return _c('OfFormInput',{staticClass:"SearchInput",attrs:{"placeholder":_vm.placeholder,"value":_vm.value,"no-vuex":"","no-label":""},on:{"input":value => _vm.$emit('input', value)},scopedSlots:_vm._u([{key:"append",fn:function(){return [_c('icon',{attrs:{"name":_vm.appendIcon},on:{"click":_vm.onAppendClick}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }